/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

const actions = {
  CONNECT: 'connect',
  SIGNIN: 'signin',
  SIGNUP: 'signup',
};

const providers = {
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  LINKEDIN: 'linkedin',
  LINKEDIN_VERIFIED: 'linkedin_verified',
  ZOOM: 'zoom',
  SURVEYMONKEY: 'surveymonkey',
  QUALTRICS: 'qualtrics',
  WEBEX: 'webex',
};

const providerDisplayNames = {
  GOOGLE: 'Google',
  OFFICE: 'Outlook',
}

const userTypes = {
  ACCOUNT: 'account',
  PARTICIPANT: 'participant',
};

export {
  actions,
  providers,
  providerDisplayNames,
  userTypes,
};
